import { Link } from '@inertiajs/react';
import { type PropsWithChildren } from 'react';

import LanguageSwitcher from '@/components/LanguageSwitcher';
import { cn } from '@/lib/utils';

interface AuthLayoutProps {
    name?: string;
    title?: string;
    description?: string;
    pageClassName?: string;
    contentClassName?: string;
    logoClassName?: string;
}

export default function AuthSimpleLayout({
    children,
    title,
    description,
    pageClassName,
    contentClassName,
    logoClassName,
}: PropsWithChildren<AuthLayoutProps>) {
    return (
        <div className={cn('flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10', pageClassName)}>
            <div className="absolute top-4 right-4">
                <LanguageSwitcher variant="buttons" showLabel={false} />
            </div>
            <div className={cn('w-full max-w-sm', contentClassName)}>
                <div className="flex flex-col gap-8">
                    <div className="flex flex-col items-center gap-4">
                        <Link href={route('home')} className="flex flex-col items-center gap-2 font-medium">
                            <div className={cn('mb-1 flex h-40 w-60 items-center justify-center rounded-xl bg-white p-2', logoClassName)}>
                                <img
                                    src="/brand/smartkondo-supplied-logo.svg"
                                    width="330"
                                    height="230"
                                    alt="SmartKondo"
                                    className="h-full w-full object-contain"
                                />
                            </div>
                            <span className="sr-only">{title}</span>
                        </Link>

                        <div className="space-y-2 text-center">
                            <h1 className="text-xl font-medium">{title}</h1>
                            <p className="text-center text-sm text-muted-foreground">{description}</p>
                        </div>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
}
